import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { TablerIconComponent } from "angular-tabler-icons";
import { BaseComponent } from "src/app/core/base/base.component";
import { HubServiceOrderCheckHistory } from "src/app/core/models/hub.model";
import { EventService } from "src/app/core/services/event.service";
import { HubService } from "src/app/core/services/hub.service";
import { InputComponent } from "../../inputs/input/input.component";

@Component({
  selector: "modal-customer-name",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    TablerIconComponent,
  ],
  templateUrl: "./customer-name.component.html",
})
export class CustomerNameBottomSheet extends BaseComponent implements OnInit {
  // inject
  private eventService = inject(EventService);
  private hubService = inject(HubService);
  private _bottomSheetRef =
    inject<MatBottomSheetRef<CustomerNameBottomSheet>>(MatBottomSheetRef);
  data = inject<{
    CustomerName?: string;
    clientName?: string;
  }>(MAT_BOTTOM_SHEET_DATA);

  // Variables
  orderCheckHistory: HubServiceOrderCheckHistory =
    new HubServiceOrderCheckHistory();

  // Form
  form = new FormGroup({
    CustomerName: new FormControl(
      this.data?.CustomerName ?? this.data?.clientName ?? "",
      [Validators.required, Validators.maxLength(30)],
    ),
  });

  //#region Getters
  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.onSubscribe();
  }

  //#region Events and synchronization
  onSubscribe() {
    this.subs.push(
      this.hubService.$orderCheckGetted.subscribe(
        (orderCheckHistory: HubServiceOrderCheckHistory) => {
          this.eventService.applyHubOrderCheckHistory(orderCheckHistory);
        },
      ),
    );

    this.subs.push(
      this.eventService.orderCheckHistoryChanged$.subscribe(
        (orderCheckHistory: HubServiceOrderCheckHistory) => {
          this.orderCheckHistory = orderCheckHistory;
        },
      ),
    );
  }

  close() {
    this._bottomSheetRef.dismiss();
  }

  handleSetCustomerName() {
    this.eventService.setOrderCheckCustomerName(
      this.f["CustomerName"].value?.trim() || "",
    );

    this.close();
  }
}
